import styled from '@emotion/styled';

import Button from 'components/field/Button';

export const FooterWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
	position: absolute;
	bottom: 2%;
	left: 50%;
	transform: translateX(-50%);

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const NavigationButton = styled(Button)`
	width: 3rem;
	height: 3rem;
	border-radius: 50%;
	background-color: var(--white) !important;
	border: 1px solid var(--border-color) !important;
	cursor: pointer;
	margin: 0 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--black);

	&.disabled {
		opacity: 1;

		.icon {
			color: var(--black-40);
		}
	}
`;

export const BulletContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: var(--white);
	border: 1px solid var(--border-color);
	border-radius: 3rem;
	padding: 0.7rem;
	width: auto;
`;

export const Bullet = styled.div`
	width: 5px;
	height: 5px;
	border-radius: 50%;
	background-color: var(--black-20);
	margin: 0 0.5rem;
	opacity: 1;
	flex-grow: 1;

	&.active {
		background-color: var(--black);
		width: 27px;
		border-radius: 3rem;
	}
`;
